import fetch from '../fetch'
import { CaseReportParamsType } from '../../models'

export type CaseReportPutParams = {
  caseReportId: string
  caseReportParams: CaseReportParamsType
}

/**
 * putCaseReport
 * - sends CaseReportParams data to the server via PUT /case-report/{id}
 */
export const putCaseReport = ({
  caseReportId,
  caseReportParams,
}: CaseReportPutParams) => {
  const token = localStorage.getItem('token')
  return fetch({
    method: 'PUT',
    path: `api/v1/case-report/${caseReportId}`,
    data: caseReportParams,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
  })
}
